export enum DeliveryType {
  DOCKET = 'docket',
  BOOKING = 'booking'
}
